'use client'

import { Button, Card, Spacer, Text } from '@vinted/web-ui'
import { useState } from 'react'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import { ElementsSelectionModel } from '@marketplace-web/domain/home-page-data'

type Props = ElementsSelectionModel['postAction']

const PostAction = (props: Props) => {
  const [isClosed, setIsClosed] = useState(false)
  const breakpoints = useBreakpoint()

  if (isClosed) return null

  return (
    <Card>
      <div className="homepage-element-selection">
        <div className="homepage-element-selection__content">
          <Text type={Text.Type.Heading} as="h2" text={props.title} />
          <Text as="p" text={props.subtitle} />
          {breakpoints.portables && <Spacer size={Spacer.Size.X2Large} />}
        </div>
        <Button
          text={props.actionTitle}
          onClick={() => setIsClosed(true)}
          inline={breakpoints.desktops}
        />
      </div>
    </Card>
  )
}

export default PostAction
